const r = {
  "cdr-grid": "cdr-grid_15-5-1",
  "cdr-grid--gutter-none": "cdr-grid--gutter-none_15-5-1",
  "cdr-grid--gutter-small": "cdr-grid--gutter-small_15-5-1",
  "cdr-grid--gutter-medium": "cdr-grid--gutter-medium_15-5-1",
  "cdr-grid--gutter-large": "cdr-grid--gutter-large_15-5-1",
  "cdr-grid--gutter-none@xs": "cdr-grid--gutter-none@xs_15-5-1",
  "cdr-grid--gutter-small@xs": "cdr-grid--gutter-small@xs_15-5-1",
  "cdr-grid--gutter-medium@xs": "cdr-grid--gutter-medium@xs_15-5-1",
  "cdr-grid--gutter-large@xs": "cdr-grid--gutter-large@xs_15-5-1",
  "cdr-grid--gutter-none@sm": "cdr-grid--gutter-none@sm_15-5-1",
  "cdr-grid--gutter-small@sm": "cdr-grid--gutter-small@sm_15-5-1",
  "cdr-grid--gutter-medium@sm": "cdr-grid--gutter-medium@sm_15-5-1",
  "cdr-grid--gutter-large@sm": "cdr-grid--gutter-large@sm_15-5-1",
  "cdr-grid--gutter-none@md": "cdr-grid--gutter-none@md_15-5-1",
  "cdr-grid--gutter-small@md": "cdr-grid--gutter-small@md_15-5-1",
  "cdr-grid--gutter-medium@md": "cdr-grid--gutter-medium@md_15-5-1",
  "cdr-grid--gutter-large@md": "cdr-grid--gutter-large@md_15-5-1",
  "cdr-grid--gutter-none@lg": "cdr-grid--gutter-none@lg_15-5-1",
  "cdr-grid--gutter-small@lg": "cdr-grid--gutter-small@lg_15-5-1",
  "cdr-grid--gutter-medium@lg": "cdr-grid--gutter-medium@lg_15-5-1",
  "cdr-grid--gutter-large@lg": "cdr-grid--gutter-large@lg_15-5-1"
};
export {
  r as default
};
